import { styled } from "styled-components";
import { device } from "../styles/stylesConfig";
import { Typography } from "./atoms/Typography";
import { Icon } from "./atoms/Icon";
import { ProductProps } from "../interfaces/TextsInterfaces";

const ButtonCard = styled.div`
    width: 220px;
    height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all 0.1s ease;
    align-self: center;
    justify-self: center;
    border-radius: 5px;
    text-align: center;

    &:nth-child(4) {
        grid-column-start: 1;
        grid-column-end: 3;
    }

    &:nth-child(5) {
        grid-column-start: 3;
        grid-column-end: 4;
        right: calc(50% + 25px);
    }

    @media ${device.xl} {
        width: 220px;
        height: 300px;
    }

    @media ${device.md} {

        &:nth-child(4) {
            grid-column-start: unset;
            grid-column-end: unset;
        }

        &:nth-child(5) {
            grid-column-start: 1;
            grid-column-end: 3;
            right: unset;
        }
    }

    @media ${device.sm} {
        width: 170px;
        height: 250px;


    }

    @media ${device.xs} {
        width: 130px;
        height: 200px;

    }

    hr {
        border: none;

        /* @media ${device.xs} {
            position: absolute;
            visibility: hidden;
        } */
    }

    img {
        width: 100% !important; 
        height: 100% !important; 
        object-fit: cover !important; 
        box-shadow: 0px 0px 12px 0px #ffffff50;
        overflow: hidden;
        border-radius: 5px;
        
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.4); 
        z-index: 1;
    }


`

const Info = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    padding: 20px;

    p {
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 2px;
    }

    @media ${device.sm} {

        p {
            font-size: 14px;
        }
    }

    @media ${device.sm} {

        p {
            font-size: 12px;
            letter-spacing: 1px;
        }
    }

`

const Button = styled.button`
    width: 90%;
    position: absolute;
    bottom: 10px;
    margin: auto;
    padding: 8px 15px; 
    background-color: #24D466;
    color: white;
    font-size: 14px;
    font-weight: 600;
    z-index: 1;
    border-radius: 8px;
    transition: all .3s ease-in-out;
    cursor: pointer;

    &:hover {
        background-color: #0ca045;
    }

    
    @media ${device.lg} {

    }

    @media ${device.sm} {
        padding: 5px 15px; 
        font-size: 12px;

    }

    @media ${device.xs} {
        font-size: 12px;

    }
`

interface Props {
    data: ProductProps;
    onClick: () => void
}

export const ProductCardItem = ({ data, onClick }: Props) => {

    return (

        <ButtonCard className="utils__fade-in-fast-top">

            <hr />

            <Icon
                size="XXL"
                src={require(`../images/${data.images[0]}`)}
            />

            <Info>

                <Typography
                    className="utils__fade-in-fast-top"
                    size='14px'
                    color="#fff"
                    style={{
                        textTransform: 'uppercase',
                    }}
                >
                    {data.title}
                </Typography>


            </Info>

            <Button onClick={() => { onClick() }}>Solicitar por WhatsApp</Button>

        </ButtonCard>

    )
}
